import { FAILED_OPT_JOB_STATUSES, OptJobWithQueueItems } from 'api/optJobs/optJobs.api'

/**
 * Filters combine with AND — picking `finished` and `failed` together matches
 * nothing, since no job is both. A job with a `creator_name` was triggered by a
 * person; the scheduler leaves it unset, and so does a user with no name on their
 * account, who therefore reads as automatic.
 */
export function matchesOptimizationFilters(job: OptJobWithQueueItems, selectedFilters: string[]): boolean {
  if (selectedFilters.length === 0) return true

  return selectedFilters.every((filter) => {
    switch (filter) {
      case 'failed':
        // "Did not succeed", which an unsolvable job also did not.
        return FAILED_OPT_JOB_STATUSES.has(job.status)
      case 'finished':
        return job.status === 'Finished'
      case 'manual':
        return Boolean(job.creator_name)
      case 'automatic':
        return !job.creator_name
      default:
        return false
    }
  })
}
